import * as React from "react";
import { ProductRecommendations } from "@grandvisionhq/products";
import { useProductRecommendation } from "@grandvisionhq/svc-product-recommendations";
const ProductRecommendationContainer = ({
  recommendationContext,
  skus,
  layout = "minicart"
}) => {
  const recommendationProps = useProductRecommendation({ recommendationContext, skus });
  return /* @__PURE__ */ React.createElement(ProductRecommendations, { ...recommendationProps, layout });
};
export {
  ProductRecommendationContainer as P
};
//# sourceMappingURL=ProductRecommendationContainer.js.map
